module.exports = __webpack_public_path__ + "img/step41.e75f709a.png";